import { axios } from '@/utils/request'

// 获取预警列表
export function getList () {
  return axios({
    url: '/sxEarlyWarning/list',
    method: 'GET'
  })
}
export function receive (id) {
  return axios({
    url: '/sxEarlyWarning/receive/' + id,
    method: 'GET'
  })
}

// 获取预警列表分页
export function getPage (params) {
  return axios({
    url: '/sxEarlyWarning/page',
    method: 'GET',
    params: params
  })
}
